import { omniTheme } from "minimum-ui/tokens";

import api from "API";

import { OrganisationScopedArgs } from "../Analytics/payloads";
import * as Omni from "./payloads";

export const standardEmbedUrlEndpoint = (dashboardId: string) =>
  `/organisations/:org/standard-dashboards/${dashboardId}/embed-url`;

export const bespokeEmbedUrlEndpoint = (dashboardId: string) =>
  `/organisations/:org/bespoke-dashboards/${dashboardId}/embed-url`;

export const omniBespokeDashboardsEndpoint =
  "/organisations/:org/bespoke-dashboards";

export const omniStandardDashboardsEndpoint =
  "/organisations/:org/standard-dashboards";

export const omniApi = api.injectEndpoints({
  endpoints: (builder) => ({
    omniBespokeDashboards: builder.query<
      Omni.OmniBespokeDashboard[],
      OrganisationScopedArgs
    >({
      query: ({ organisationId }) =>
        omniBespokeDashboardsEndpoint.replace(":org", organisationId),
    }),
    omniStandardDashboards: builder.query<
      Omni.OmniStandardDashboard[],
      OrganisationScopedArgs
    >({
      query: ({ organisationId }) =>
        omniStandardDashboardsEndpoint.replace(":org", organisationId),
    }),
    standardDashboardEmbedUrl: builder.mutation<
      Omni.EmbedUrlResponse,
      Omni.StandardEmbedUrlParams
    >({
      query: ({ dashboardId, entityPk }) => ({
        url: standardEmbedUrlEndpoint(dashboardId),
        method: "POST",
        body: { entity: entityPk, customTheme: omniTheme },
      }),
    }),
    bespokeDashboardEmbedUrl: builder.mutation<
      Omni.EmbedUrlResponse,
      Omni.BespokeEmbedUrlParams
    >({
      query: ({ dashboardId }) => ({
        url: bespokeEmbedUrlEndpoint(dashboardId),
        method: "POST",
        body: { customTheme: omniTheme },
      }),
    }),
  }),
});

export const {
  useOmniBespokeDashboardsQuery,
  useOmniStandardDashboardsQuery,
  useStandardDashboardEmbedUrlMutation,
  useBespokeDashboardEmbedUrlMutation,
} = omniApi;
